// import { Button } from '@fluentui/react-components'
import { Button } from '@/components/shadcn/button'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { CloudFlowRegular } from '@fluentui/react-icons'
import AddPipelineFormV2 from '../../Forms/AddPipelineFormV2'

type MessagesPipelinesExistingPipeline = RestSchemas['Messages.Pipeline.ExistingPipeline']

export function PipelineCardButtons({ pipeline }: { pipeline: MessagesPipelinesExistingPipeline }) {
  const { applicationId } = pipeline

  const { getPipelineApiGetPipeline } = useRestClient()

  const invalidatePipelines = () => {
    getPipelineApiGetPipeline.invalidateQueries({ parameters: { path: { applicationId } } })
  }

  return (
    <AddPipelineFormV2
      mode="definition"
      sheetTitle="Edit Pipeline Definition"
      sheetDescription="Edit the pipeline definition"
      selectedPipeline={pipeline}
      sheetTrigger={
        <Button size="sm" variant="outline" className="h-6">
          <CloudFlowRegular />
          <span className="ml-2">Pipeline definition</span>
        </Button>
      }
      onSubmit={() => {
        invalidatePipelines()
      }}
    />
  )
}
